import { defineService } from '@nzyme/ioc/Service.js';
import { LanguageContext } from './LanguageContext.js';
import { translateToString } from './translateToString.js';
/** Injectable service that translates using the current language from LanguageContext. */
export const Translator = defineService({
    name: 'Translator',
    deps: {
        lang: LanguageContext,
    },
    setup({ lang }) {
        return (translation, params) => {
            return translateToString(translation, lang(), params);
        };
    },
});
//# sourceMappingURL=Translator.js.map